/* MIRAVOA — interacciones propias (prefijo mv-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mv-reveal:not(.mv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mv-count]:not([data-mv-done])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-mv-done', '1');
      var fin = parseFloat(el.getAttribute('data-mv-count')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toLocaleString('es-ES', { minimumFractionDigits: dec }); return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 4));
        el.textContent = v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mv-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var f = parseFloat(el.getAttribute('data-mv-parallax')) || 0;
        var y = (r.top + r.height / 2 - window.innerHeight / 2) * f * -0.01;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initGaleria() {
    document.querySelectorAll('[data-mv-galeria]').forEach(function (g) {
      if (g.dataset.mvInit) return; g.dataset.mvInit = '1';
      var principal = g.querySelector('[data-mv-principal]');
      g.querySelectorAll('[data-mv-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('[data-mv-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var partes = v.split('.');
    var conPuntos = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComas = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conPuntos + ',' + partes[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, conPuntos)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, conComas)
      .replace(/\{\{\s*amount\s*\}\}/, conComas + '.' + partes[1]);
  }

  function initVariantes() {
    document.querySelectorAll('[data-mv-producto]').forEach(function (root) {
      if (root.dataset.mvInit) return; root.dataset.mvInit = '1';
      var dataEl = root.querySelector('[data-mv-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var formato = root.getAttribute('data-money-format');
      var inputId = root.querySelector('input[name="id"]');
      var precio = root.querySelectorAll('[data-mv-precio]');
      var antes = root.querySelectorAll('[data-mv-antes]');
      var botones = root.querySelectorAll('[data-mv-comprar]');
      var textoAgotado = root.getAttribute('data-texto-agotado') || 'Agotado';

      function actualizar() {
        var sel = [];
        root.querySelectorAll('[data-mv-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = formatoDinero(v.price, formato); });
        antes.forEach(function (a) {
          if (v.compare_at_price && v.compare_at_price > v.price) { a.textContent = formatoDinero(v.compare_at_price, formato); a.hidden = false; }
          else a.hidden = true;
        });
        botones.forEach(function (b) {
          if (!b.dataset.textoOriginal) b.dataset.textoOriginal = b.textContent.trim();
          b.disabled = !v.available;
          b.textContent = v.available ? b.dataset.textoOriginal : textoAgotado;
        });
        if (window.history.replaceState && root.hasAttribute('data-mv-url')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      root.querySelectorAll('[data-mv-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var q = root.querySelector('[data-mv-cantidad]');
      if (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n = b.getAttribute('data-dir') === '+' ? n + 1 : Math.max(1, n - 1);
            input.value = n;
          });
        });
      }
    });
  }

  function initBarraFija() {
    var barra = document.querySelector('[data-mv-barra]');
    var objetivo = document.querySelector('[data-mv-barra-objetivo]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', pasado);
      });
    }).observe(objetivo);
  }

  function initFaq() {
    document.querySelectorAll('[data-mv-faq-unico]').forEach(function (lista) {
      if (lista.dataset.mvInit) return; lista.dataset.mvInit = '1';
      var items = lista.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initPacks() {
    document.querySelectorAll('[data-mv-packs]').forEach(function (packs) {
      if (packs.dataset.mvInit) return; packs.dataset.mvInit = '1';
      var form = packs.closest('form');
      var qty = form && form.querySelector('input[name="quantity"]');
      if (!qty) return;
      function sync() {
        var c = packs.querySelector('input:checked');
        if (c) qty.value = c.value;
      }
      packs.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', sync); });
      sync();
    });
  }

  function initEntrega() {
    document.querySelectorAll('[data-mv-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 10;
      var max = parseInt(el.getAttribute('data-max'), 10) || 15;
      if (max < min) { var x = min; min = max; max = x; }
      var plantilla = el.getAttribute('data-texto') || 'Recíbelo entre el [desde] y el [hasta]';
      var hoy = new Date();
      function fecha(dias) {
        var d = new Date(hoy.getTime()); d.setDate(d.getDate() + dias);
        try { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); }
        catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
      }
      var out = el.querySelector('[data-mv-entrega-fechas]');
      if (out) out.textContent = plantilla.replace('[desde]', fecha(min)).replace('[hasta]', fecha(max));
    });
  }

  function init() {
    initReveal(); initContadores(); initParallax(); initGaleria();
    initVariantes(); initBarraFija(); initFaq(); initPacks(); initEntrega();
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
